import { render, staticRenderFns } from "./PopupBackupData.vue?vue&type=template&id=5a22e853&"
import script from "./PopupBackupData.vue?vue&type=script&lang=js&"
export * from "./PopupBackupData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports